import React, { useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { Avatar, Menu, message, Dropdown } from 'antd'
import { contexts } from '@/domains'
import { globalStore } from '@/GlobalStore'
import ProfileSetupModal from '@/components/ProfileSetupModal/ProfileSetupModal'
import ProfileModal from '@/profile/ProfileModal'
import "./Baisc.css"

const items = [
  {
    key: '/home',
    label: '工作台'
  },
  {
    key: '/demand',
    label: '需求管理'
  },
  {
    key: '/project',
    label: '项目管理'
  },
  {
    key: '/delivery',
    label: '周交付'
  },
  {
    key: '/bug',
    label: '缺陷管理'
  }
]

const { GlobalContext } = contexts

function Basic(): JSX.Element {
  const [profileModalOpen, setProfileModalOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const { userInfo, changeTeam } = GlobalContext.useContainer()
  const sortedTeams = globalStore.getSortedTeamList()
  const isTeamAdmin = globalStore.isCurrentTeamAdmin()

  const handleMenuClick = ({ key }): void => {
    if (!['/home','/project', '/delivery', '/demand', '/bug'].includes(key)) {
      message.info('该功能尚未开放', 1)
      return
    }
    navigate(key)
  }

  const stringToColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `hsl(${hash % 360}, 70%, 50%)`;
    return color;
  };

  return (
    <div className="main-container">
      <ProfileSetupModal
        open={globalStore.profileSetupPrompt}
        onClose={() => globalStore.dismissProfileSetupPrompt()}
        onOpenProfile={() => setProfileModalOpen(true)}
      />
      <ProfileModal open={profileModalOpen} onClose={() => setProfileModalOpen(false)} />
      <div className="header-wrapper">
        <div className="inner">
          <div className="header-left">
            <a href="" className="logo"></a>
            <div className="flex flex-col">
              <span className="brand-name">麻雀</span>
              <span className="brand-desc">专业远程交付管理系统</span>
            </div>
          </div>
          <div className="header-right">
            <Menu
              theme="dark"
              style={{ color: '#fff', backgroundColor: 'transparent', border: 'none' }}
              mode="horizontal"
              selectedKeys={[location.pathname]}
              items={items}
              onClick={handleMenuClick}
            />
            <div className="avatar-wrapper">
              <Dropdown
                popupRender={() => (
                  <Menu>
                    <Menu.Item
                      onClick={() => setProfileModalOpen(true)}
                      style={{fontWeight:'200'}}
                    >
                      个人资料
                    </Menu.Item>
                    {isTeamAdmin && (
                      <Menu.Item
                        onClick={() => {
                          navigate('/team-members')
                        }}
                        style={{fontWeight:'200'}}
                      >
                        成员管理
                      </Menu.Item>
                    )}
                    <Menu.Divider />
                    {userInfo && sortedTeams.length > 0 && (
                        <Menu.SubMenu title={<span style={{fontWeight:'200'}}>切换团队</span>}>
                          {sortedTeams.map((item) => (
                            <Menu.Item
                              key={item.id}
                              onClick={() => {
                                changeTeam(item.id);
                              }}
                            >
                              <div className="menu-item-container">
                                <div className="avatar-section">
                                  <Avatar
                                    src={item.teamUrl}
                                    size="large"
                                    style={{
                                      backgroundColor: !item.teamUrl ? stringToColor(item.teamName) : undefined,
                                      marginRight: 8
                                    }}
                                  >
                                    {!item.teamUrl && item.teamName.charAt(0)}
                                  </Avatar>
                                </div>
                                <div className="info-section">
                                  <div className="team-name">{item.teamName}</div>
                                  <div className="company-name">{item.teamDesc}</div>
                                </div>
                                <div className="people-count-section">
                                  {item.userList?item.userList.length:0}人
                                </div>
                              </div>
                            </Menu.Item>
                          ))}
                        </Menu.SubMenu>
                      )}

                    <Menu.Divider />
                    <Menu.Item
                      onClick={() => {
                        navigate('/login')
                      }}
                      style={{fontWeight:'200'}}
                    >
                      退出登录
                    </Menu.Item>
                  </Menu>
                )}
              >
                <Avatar src={userInfo?.userAvatar} />
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div className="content-wrapper">
        <div className="inner">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default observer(Basic)
